export enum VehicleActions {
  CREATE_VEHICLE = "create_vehicle",
  UPDATE_VEHICLE = "update_vehicle",
  UPDATE_VEHICLE_ID = "update_vehicle_id",
  LIST_VEHICLES = "list_vehicles",
}